<template>
    <div class="game" @touchmove.prevent>
        <!-- 顶部元素 -->
        <img src="http://cdn.shikehuyu.com/card/game-link.png?v=1.0.3" class="game__link">
        <img src="http://cdn.shikehuyu.com/card/game-click.png?v=1.0.1" class="game__click" @click="jump">
        <img src="http://cdn.shikehuyu.com/card/game-link-finger.png?v=1.0.0" class="game__link__finger wanderVer1">
        <img :src="musicIcon" class="game__music" @click="toggleMusic">
        <!-- 主要内容 -->
        <div class="game__cnt" :class="{ showGame: !showVideo }">
            <transition name="fade">
                <img src="http://cdn.shikehuyu.com/card/game-title-video.png?v=1.0.2" class="game__title" v-show="showVideo"
                    :style="isReplay ? 'visibility: hidden' : ''">
            </transition>
            <div class="game__video"
                :class="{ fade: !showCard, animated: !isReplay, zoomIn: !isReplay }">
                <div class="game__video__inner" @click="playVideo">
                    <!-- 视频 -->
                    <img src="http://cdn.shikehuyu.com/card/game-play.png?v=1.0.0" class="game__video__inner__play"
                        v-show="showVideoPlay && !isReplay">
                    <transition name="fade">
                        <video src="http://cdn.shikehuyu.com/card/card.mp4?v=1.0.3"
                            class="game__video__inner__video"
                            v-show="showVideo && !isReplay"
                            poster="" x5-playsinline playsinline webkit-playsinline
                            @ended="videoEnd">
                        </video>
                    </transition>
                    <!-- 拼图 -->
                    <div class="game__video__inner__puzzle" v-show="showGame">
                        <div class="game__video__inner__puzzle__item"
                            v-for="(item, index) in puzzleItems"
                            :key="index"
                            @touchstart="selectPuzzleItem(index)"
                            :class="'game__video__inner__puzzle__item--' + index
                                + ' game__video__inner__puzzle__item--p' + item
                                + (currentSelect === index ? ' selected' : '')
                                + (showGame ? ' show' : '')
                                + (showPuzzleTransition ? ' transition' : '')">
                        </div>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <img src="http://cdn.shikehuyu.com/card/game-subtitle-video.png?v=1.0.0" class="game__subtitle" v-show="showVideo"
                    :style="isReplay ? 'visibility: hidden' : ''">
            </transition>
            <!-- 游戏部分的文本 -->
            <transition name="fade">
                <img src="http://cdn.shikehuyu.com/card/game-title-2.png?v=1.0.0" class="game__title game__title--game" v-show="showGame">
            </transition>
            <transition name="fade">
                <div class="game__progress" v-show="showGame">
                    <div class="game__progress__inner">
                        <div class="game__progress__inner__bar" :style="progressBarWidth">
                            <img src="http://cdn.shikehuyu.com/card/game-progress-slider.png?v=1.0.0" alt=""
                                class="game__progress__inner__bar__slider">
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <img src="http://cdn.shikehuyu.com/card/game-subtitle-2.png?v=1.0.3" class="game__subtitle game__subtitle--game" v-show="showGame">
            </transition>
        </div>
        <!-- 底部元素 -->
        <div class="game__skip" @click="videoSkip" v-show="showVideo">跳过视频</div>
        <img src="http://cdn.shikehuyu.com/card/game-logo.png?v=1.0.2" class="game__logo">
        <!-- 突出卡模态窗 -->
        <transition name="fade">
            <div class="game__card__mask" v-show="showCardBright && showCard"
                :style="isReplay ? 'visibility: hidden' : ''">
            </div>
        </transition>
        <transition name="fade">
            <div class="game__card"
                :class="{ zoomIn: showCard, animated: showCard }"
                :style="isReplay ? 'visibility: hidden' : ''"
                v-show="showCard">
                <transition name="fade">
                    <img src="http://cdn.shikehuyu.com/card/game-light.png?v=1.0.0" class="game__card__light rotate"
                         v-show="showCardBright">
                </transition>
                <img src="http://cdn.shikehuyu.com/card/game-card.png?v=1.0.2" class="game__card__card" :class="{ fade: !showCardBright }">
            </div>
        </transition>
        <!-- 失败 -->
        <transition name="fade">
            <div class="game__lose" v-show="showLose">
                <div class="game__lose__cnt">
                    <div class="game__lose__cnt__inner animated bounceInDown">
                        <img src="http://cdn.shikehuyu.com/card/game-lose.png?v=1.0.0" class="game__lose__cnt__inner__bg">
                        <img src="http://cdn.shikehuyu.com/card/game-again.png?v=1.0.0" class="game__lose__cnt__inner__again"
                            @click="playAgain">
                        <img src="http://cdn.shikehuyu.com/card/game-giveup.png?v=1.0.0" class="game__lose__cnt__inner__giveup"
                            @click="giveup">
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'game',
    data() {
        const puzzleItems = {};
        for (let i = 0; i < 9; i += 1) {
            puzzleItems[i] = i;
        }
        const isReplay = !!this.$route.query.replay;
        return {
            musicOn: this.$bus.musicOn,
            time: 30000, // 还有多少秒

            showVideoPlay: true, // 播放按钮
            showCardBright: true, // 卡的光芒和遮罩
            showCard: true, // 卡
            showVideo: true, // 视频
            showGame: false, // 游戏

            puzzleItems,
            currentSelect: null, // 当前选择的拼图
            showPuzzleTransition: false, // 拼图移动是否过渡
            enableSelect: false, // 是否允许拼图

            showLose: false, // 闯关失败
            isReplay, // 是否重玩
        };
    },
    computed: {
        musicIcon() {
            return `http://cdn.shikehuyu.com/card/icon-music-${this.musicOn ? 'on' : 'off'}.png?v=1.0.0`;
        },
        progressBarWidth() {
            const progress = this.time <= 0 ? 100 : (30000 - this.time) / 30000 * 100;
            return `width: ${progress}%`;
        }
    },
    methods: {
        jump() {
            this.$bus.playMusic('click');
            this.$bus.jump();
        },
        toggleMusic() {
            this.$bus.toggleMusic();
            this.musicOn = this.$bus.musicOn;
            if (this.musicOn) {
                this.$bus.musicFadeIn('bg', 0, 0.5);
            } else {
                this.$bus.musicFadeOut('bg', 0.5, 0);
            }
            this.$bus.playMusic('click');
        },
        playVideo() {
            if (this.video.paused && this.showVideo) {
                if (this.musicOn) this.$bus.musicFadeOut('bg', 0.5, 0);
                this.video.play();
                this.showVideoPlay = false;
                if (this.isAndroid) this.drawCanvas();
            }
        },
        hideCardBright() {
            this.showCardBright = false;
        },
        hideCard() {
            this.showCard = false;
        },
        videoSkip() {
            this.video.pause();
            this.videoEnd();
        },
        videoEnd() {
            if (this.musicOn) this.$bus.musicFadeIn('bg', 0, 0.5);
            this.showVideo = false;
            setTimeout(() => {
                this.showGame = true;
                setTimeout(() => {
                    this.prepareGame();
                }, 2000);
            }, 1000);
        },

        // 准备游戏
        prepareGame() {
            this.showPuzzleTransition = true;
            this.randomPuzzle();
            setTimeout(() => {
                this.showPuzzleTransition = false;
                this.startGame();
            }, 1500);
        },
        // 开始游戏
        startGame() {
            this.enableSelect = true;
            this.countdown();
        },
        // 游戏结束
        endGame() {
            this.enableSelect = false;
            if (this.win) {
                setTimeout(() => {
                    this.$router.replace('lottery');
                }, 1500);
                console.log('游戏结束，胜利');
            } else {
                console.log('游戏结束，失败');
                this.showLose = true;
            }
        },
        // 重置游戏
        resetGame() {
            this.time = 30000;
            this.currentSelect = null;
        },
        // 再玩一次
        playAgain() {
            this.$bus.playMusic('click');
            this.showLose = false;
            this.resetGame();
            this.prepareGame();
        },
        // 不玩了
        giveup() {
            this.$bus.playMusic('click');
            this.$router.replace('share');
        },

        // 倒计时
        countdown() {
            this.time -= 100;
            if (this.time <= 0) {
                this.time = 0;
                clearTimeout(this.countdownTimeout);
                this.win = false;
                this.endGame();
            } else {
                this.countdownTimeout = setTimeout(() => {
                    this.countdown();
                }, 100);
            }
        },
        // 打乱拼图
        randomPuzzle() {
            const arr = Object.values(this.puzzleItems);
            arr.sort(() => Math.random() - 0.5);
            arr.sort(() => Math.random() - 0.5);
            arr.forEach((value, index) => {
                this.puzzleItems[index] = value;
            });
        },
        // 选中拼图
        selectPuzzleItem(index) {
            if (this.enableSelect) {
                this.$bus.playMusic('click');
                if (this.currentSelect === null) { // 开始选中
                    this.currentSelect = index;
                } else if (this.currentSelect === index) { // 选中同一块
                    this.currentSelect = null;
                } else { // 交换
                    const tmp = this.puzzleItems[this.currentSelect];
                    this.puzzleItems[this.currentSelect] = this.puzzleItems[index];
                    this.puzzleItems[index] = tmp;
                    this.currentSelect = null;
                    this.judge();
                }
            }
        },
        // 判断是否胜利
        judge() {
            const wrongPuzzles = Object.keys(this.puzzleItems)
                .filter(key => this.puzzleItems[key] !== Number(key));
            if (wrongPuzzles.length > 0) {
                console.log('错误的拼图', wrongPuzzles);
            } else {
                clearTimeout(this.countdownTimeout);
                this.win = true;
                this.endGame();
            }
        },
    },
    mounted() {
        this.video = document.querySelector('.game__video__inner__video');
        if (this.$route.query.replay) { // 再玩一次
            this.hideCardBright();
            this.hideCard();
            this.videoEnd();
        } else {
            setTimeout(() => {
                this.hideCardBright();
                setTimeout(() => {
                    this.hideCard();
                }, 2000);
            }, 4000);
        }
        window.game = this;
    }
};
</script>

<style lang="scss">
@import '../style/mixin.scss';
@import '../style/color.scss';
@import '../style/animation.scss';

.game {
    @include fullscreen;
    @include bg-cover;
    background-position: right center;
    background-image: url('http://cdn.shikehuyu.com/card/game-bg.png?v=1.0.0');
    &__link {
        position: absolute;
        padding: 2vw 1vw;
        top: 0;
        left: 0;
        width: 14vw;
        &__finger {
            position: absolute;
            padding: 2vw 1vw;
            top: 2.5%;
            left: 2.5%;
            width: 8.5%;
            z-index: 1;
        }
    }
    &__click {
        position: absolute;
        padding: 8vw 1vw;
        top: 2%;
        left: -1%;
        width: 18%;
        z-index: 2;
    }
    &__skip {
        position: absolute;
        bottom: 11.5%;
        left: 40.5%;
        width: 19.86vw;
        height: 5.47vh;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: FZLTZHK--GBK1-0;
        border-radius: 10px;
        border: solid 1px #ffffff;
        font-size: 16px;
        color: #ffffff;
    }
    &__music {
        position: absolute;
        padding: 2vw 1vw;
        top: 0;
        right: 0;
        width: 12vw;
    }
    &__logo {
        @include transform-center-x;
        bottom: 3vh;
        width: 76vw;
    }
    &__cnt {
        @include transform-center;
        transition: all ease-out 1s;
        &.showGame {
            transform: translate(-50%, -30%);
        }
    }
    &__title {
        position: absolute;
        bottom: 100%;
        left: 50%;
        width: 70vw;
        transform: translate(-50%, -4vw);
        &--game {
            transform: translate(-50%, -18vw);
        }
    }
    &__subtitle {
        position: absolute;
        top: 100%;
        left: 50%;
        width: 58vw;
        transform: translate(-50%, 3vw);
        &--game {
            width: 70vw;
            transform: translate(-50%, 4vw);
        }
    }
    &__video {
        border-radius: .18rem;
        background: white;
        box-shadow: 0px 0px 4px 2px rgba(255, 241, 126, 0.5);
        padding: 10px;
        box-sizing: border-box;
        font-size: 0px;
        width: 93.87vw;
        height: 61.33vw;
        margin: 0 auto;
        transition: all linear 1s;
        &.animated {
            animation-duration: 2s;
        }
        &.fade {
            box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.2);
        }
        &__inner {
            border-radius: .12rem;
            overflow: hidden;
            width: 100%;
            height: 100%;
            position: relative;
            &__video {
                background-color: #323131;
                position: relative;
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center;
            }
            &__play {
                @include transform-center;
                width: 18.67vw;
                z-index: 1;
            }
            &__puzzle {
                top: 0;
                left: 0;
                position: absolute;
                z-index: 2;
                width: 100%;
                height: 100%;
                border-radius: .12rem;
                overflow: hidden;
                &__item {
                    position: absolute;
                    left: 0;
                    width: 33.3%;
                    height: 33.3%;
                    background-image: url('http://cdn.shikehuyu.com/card/game-card.png?v=1.0.2');
                    background-size: 300%;
                    background-repeat: no-repeat;
                    box-shadow: 0px 0px 0px 1px #d2cdc9;
                    border: 1px solid transparent;
                    box-sizing: border-box;
                    background-color: #d2cdc9;
                    transition: box-shadow linear .1s, top ease-out 1s, opacity ease-out 1s;
                    opacity: 0;
                    top: -.2rem;
                    &.transition {
                        transition:
                            box-shadow linear .1s,
                            top ease-out 1s,
                            opacity ease-out 1s,
                            transform ease-out 1s;
                    }
                    &.show {
                        animation-name: puzzleShow;
                        animation-duration: 1s;
                        animation-fill-mode: forwards;
                    }
                    &.selected {
                        z-index: 1;
                        box-shadow: 0px 0px 4px 2px rgba(255, 241, 126, 0.5);
                    }
                    &--p0 {
                        transform: translate(0, 0);
                    }
                    &--p1 {
                        transform: translate(100%, 0);
                    }
                    &--p2 {
                        transform: translate(200%, 0);
                    }
                    &--p3 {
                        transform: translate(0, 100%);
                    }
                    &--p4 {
                        transform: translate(100%, 100%);
                    }
                    &--p5 {
                        transform: translate(200%, 100%);
                    }
                    &--p6 {
                        transform: translate(0, 200%);
                    }
                    &--p7 {
                        transform: translate(100%, 200%);
                    }
                    &--p8 {
                        transform: translate(200%, 200%);
                    }
                    &--0 {
                        background-position: left top;
                        animation-delay: .2s;
                    }
                    &--1 {
                        background-position: center top;
                        animation-delay: .6s;
                    }
                    &--2 {
                        background-position: right top;
                        animation-delay: .5s;
                    }
                    &--3 {
                        background-position: left center;
                        animation-delay: .4s;
                    }
                    &--4 {
                        background-position: center center;
                    }
                    &--5 {
                        background-position: right center;
                        animation-delay: .3s;
                    }
                    &--6 {
                        background-position: left bottom;
                        animation-delay: .4s;
                    }
                    &--7 {
                        background-position: center bottom;
                        animation-delay: .8s;
                    }
                    &--8 {
                        background-position: right bottom;
                        animation-delay: .7s;
                    }
                }
            }
        }
    }
    @keyframes puzzleShow {
        from {
            top: -.1rem;
            opacity: 0;
        }
        to {
            top: 0rem;
            opacity: 1;
        }
    }
    &__progress {
        background: white;
        position: absolute;
        bottom: 100%;
        left: 50%;
        width: 90vw;
        height: 7vw;
        border-radius: 3.5vw;
        transform: translate(-50%, -8vw);
        box-shadow: 0px 0px 20px 0px rgba(60, 51, 152, 0.5);
        padding: 1.2vw;
        box-sizing: border-box;
        &__inner {
            background: linear-gradient(to right, #7caded, #eb7dec);
            height: 4.6vw;
            width: 100%;
            border-radius: 2.3vw;
            position: relative;
            &__bar {
                transition: width linear .1s;
                position: absolute;
                background: #c2c4ca;
                width: 0%;
                right: 0;
                top: 0;
                height: 100%;
                border-radius: 2.3vw;
                &__slider {
                    position: absolute;
                    width: 5.34vw;
                    left: 0;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }
    &__card {
        @include fullscreen;
        @include box;
        z-index: 10;
        &.hidden {
            visibility: hidden;
        }
        &.animated {
            animation-duration: 2s;
        }
        &__mask {
            @include fullfill;
            background: rgba(0, 0, 0, 0.8);
            z-index: 10;
            &.hidden {
                visibility: hidden;
            }
        }
        &__light {
            z-index: 3;
            width: 100%;
            animation-duration: 120s;
            &.rotate {
                animation-duration: 120s;
            }
        }
        &__card {
            @include transform-center;
            z-index: 4;
            width: 89.47vw;
            border-radius: .1rem;
            transition: all linear 1s;
            box-shadow: 0px 0px 30px 10px rgba(255, 241, 126, 0.5);
            &.fade {
                box-shadow: 0px 0px 4px 0px rgba(255, 241, 126, 0.5);
            }
        }
    }
    &__lose {
        @include fullfill;
        @include box;
        z-index: 6;
        background: rgba(0, 0, 0, 0.8);
        &__cnt {
            transform: translate(0, -50%);
            &__inner {
                position: relative;
                font-size: 0px;
                &__bg {
                    width: 82vw;
                }
                &__again {
                    position: absolute;
                    bottom: 11.6%;
                    right: 50%;
                    transform: translate(-1vw, 0);
                    width: 30vw;
                }
                &__giveup {
                    position: absolute;
                    bottom: 11.6%;
                    left: 50%;
                    transform: translate(1vw, 0);
                    width: 30vw;
                }
            }
        }
    }
}
@media screen and (max-height: 602px) {
.game {
    &__subtitle {
        transform: translate(-50%, 0vw);
    }
}
}
</style>




// WEBPACK FOOTER //
// src/components/game.vue